import http from '../_http'

//billing - admin
const billing_admin = {
  //pay Partner
  payPAdmin: (m) => { return http.post(`manager/billing/admin/partner/pay`, m); },

  //default
  summaryAdmin: (m) => { return http.get(`manager/billing/admin`, m); },

  //agent Status
  statusAdmin: (m) => { return http.get(`manager/billing/admin/agent/status`, m); },

  //issue
  issueAdmin: (m) => { return http.post(`manager/billing/admin/issue`, m); },
  issueGAdmin: (m) => { return http.post(`manager/billing/admin/group/issue`, m); },
  issuePAdmin: (m) => { return http.post(`manager/billing/admin/partner/issue`, m); },

  //init partner
  initPAdmin: (m) => { return http.get(`manager/billing/admin/partner/init/${m.id}`); },
  initGAdmin: (m) => { return http.post(`manager/billing/admin/group/init`, m); },
  
  //delete Group
  deleteGAdmin: (m) => { return http.post(`manager/billing/admin/group/delete`, m); },
}

export default billing_admin